export type AvailableLocales = 'de' | 'en' | 'es' | 'fr' | 'it' | 'pt';
import type { Dictionary } from '@emobg/web-utils';

export const LOCALES: Dictionary<AvailableLocales> = {
  de: 'de',
  en: 'en',
  es: 'es',
  fr: 'fr',
  it: 'it',
  pt: 'pt',
} as const;

export const PREFERRED_COUNTRIES: readonly string[] = ['ES', 'GB', 'DE', 'FR', 'PT', 'IT', 'NL', 'SE', 'RU', 'AD', 'AE'] as const;
